// Module
var code = "<h2 id=\"trouble-paying\">Trouble Paying?</h2> <p>Learn what options are available to help. </p> ";
// Exports
export default code;